// export const BASE_URL = 'http://localhost:8000/';
export const BASE_URL = 'https://store-pos-backend.onrender.com/';
